import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Params, RouterLinkActive, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';

export interface CounterConfig {
  content: {
    title: string;
    value: any;
    icon?: string;
    titleClass?: string
  },
  link?: {
    routerLink?: any[];
    queryParams?: Params;
  },
  actions?: {
    condition?: () => boolean;
    icon: string;
    click: () => void;
    tooltip: string;
  }[];
}

@Component({
    selector: 'app-counter',
    templateUrl: './counter.component.html',
    styleUrls: ['./counter.component.scss'],
    imports: [NgClass, NgTemplateOutlet, TooltipDirective, TranslatePipe, RouterLink]
})
export class CounterComponent implements OnInit {
  @Input() configs!: CounterConfig;

  actions: any[] = [];

  ngOnInit(): void {
    this.actions = this.configs?.actions ?? [];
  }

}
